import { render, staticRenderFns } from "./RentsPerUser.vue?vue&type=template&id=51bcf3fa&"
import script from "./RentsPerUser.vue?vue&type=script&lang=js&"
export * from "./RentsPerUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports